import styled from 'styled-components';

export const StyledSwitchContainer = styled.div`
  margin-top: 30px;
  display: flex;
  align-items: flex-start;
  p {
    font-size: 16px;
  }
`;
